module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/map-dynamic-small-purple-pin-ballon-with-outline-9b71d53e5664ed3f1c5e90c8dbe13fae.svg";